<template>
  <md-card class="md-card-login" :class="{ 'md-card-hidden': cardHidden }">
    <md-card-header :class="getClass(headerColor)">
      <slot name="title"></slot>
      <div class="social-line">
        <slot name="buttons"></slot>
      </div>
    </md-card-header>

    <md-card-content>
      <slot name="description"></slot>
      <slot name="inputs">
        <div id="inputs">
          <div class="title">
            <h3>Inputs</h3>
          </div>
          <div class="md-layout">
            <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
            >
              <md-field>
                <md-input v-model="initial" placeholder="Regular"></md-input>
              </md-field>
            </div>
            <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
            >
              <md-field>
                <label>With Floating Label</label>
                <md-input v-model="floatingLabel" type="text"></md-input>
              </md-field>
            </div>
            <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
            >
              <md-field class="md-valid">
                <label>Success Input</label>
                <md-input v-model="success" type="text"></md-input>
                <md-icon>done</md-icon>
              </md-field>
            </div>
            <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
            >
              <md-field class="md-error">
                <label>Error Input</label>
                <md-input v-model="error" type="text"></md-input>
                <md-icon>clear</md-icon>
              </md-field>
            </div>
            <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
            >
              <md-field class="md-form-group">
                <md-icon>face</md-icon>
                <md-input
                    v-model="withMIcon"
                    placeholder="With Material Icons"
                ></md-input>
              </md-field>
            </div>
            <div
                class="md-layout-item md-size-25 md-xsmall-size-100 md-small-size-50 md-medium-size-25"
            >
              <md-field class="md-form-group">
                <i class="fas fa-users"></i>
                <md-input
                    v-model="withFaIcon"
                    placeholder="With Font Awesome Icons"
                ></md-input>
              </md-field>
            </div>
          </div>
        </div>
      </slot>
    </md-card-content>

    <md-card-actions>
      <slot name="footer"></slot>
    </md-card-actions>
  </md-card>
</template>

<script>
export default {
  name: "login-card",
  props: {
    headerColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      cardHidden: true
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    showCard: function() {
      this.cardHidden = false;
    },
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    }
  }
};
</script>

<style lang="css"></style>
